import { FormTemplateFieldMap } from 'data/template/template.types';

export const TARGETS_DEFAULT_LAYOUT_ORDER = ['options', 'primaryValue', 'secondaryType', 'secondaryValue', 'optionValue'];

export const getSortedFormTemplateLayout = (
  formTemplateFields: FormTemplateFieldMap, layoutOrder: string[],
): string[][] => {
  const row = Object.keys(formTemplateFields);

  row.sort((a, b) => {
    return layoutOrder.indexOf(a) - layoutOrder.indexOf(b);
  });

  return [row];
};
